<ng-container *transloco="let t">
  <div class="container sign-norwegian-bankId-container" *ngIf="currentAuthDetails">
    <div class="bankId-box-header border-bottom pb-1">
      <h2>
        {{ t(currentAuthDetails.header, { document: roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name }) }}
      </h2>
    </div>

    <div class="norwegian-bankId-box-tab-content">
      <div class="norwegian-bankId-tab-content-left">
        <h5 class="norwegian-bankId-tab-title">
          <strong>{{ roleDetail?.recipient?.firstname }} {{ roleDetail?.recipient?.lastname ?? '' }} </strong>
          <span>{{ t(currentAuthDetails.boxLabelTranslation) }}</span>
        </h5>

        <button
          type="button"
          class="btn btn-success signWith-norwegian-BankId-process-btn"
          (click)="processNorwegianBankId($event)"
          (touchstart)="processNorwegianBankId($event)"
        >
          <span>{{ t(currentAuthDetails.button) }}</span>
          <img
            [src]="currentAuthDetails.logo"
            [class]="currentAuthDetails.logoClass"
            [style.width]="currentAuthDetails.logoWidth"
          />
        </button>
      </div>

      <div class="norwegian-bankId-tab-content-right">
        <p>{{ t(currentAuthDetails.description) }}.</p>
      </div>
    </div>
  </div>
</ng-container>
